module.exports = __webpack_public_path__ + "img/salzburg-logo-icon.6c5ea879.png";